<div class="input-component"
     #inputZone
     [ngClass]="{'pristine': pristine, 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': disabled}">
    <div class="input-wrapper"
         (click)="onClick()">
        <div class="zone-display">
            <span *ngIf="value">{{value ? value[title] : 'vide'}}</span>
        </div>

        <!-- <label [attr.for]="fieldId">{{label}}</label> -->
        <div class="zone-validation">
            <span class="input-validation fa-stack fa-1x"
                  *ngIf="dirty">
                <i class="fas fa-stack-2x fa-circle"
                   aria-hidden="true"></i>
                <i class="fal fa-stack-1x"
                   [ngClass]="(validStatus$ | async) ? 'fa-check' : 'fa-times'"
                   aria-hidden="true"></i>
            </span>
        </div>
        <div class="zone-arrow">
            <span class="dropdown-arrow">
                <i class="fas fa-triangle"
                   [ngClass]="{'fa-rotate-180': this.direction === 'desc'}"
                   aria-hidden="true">
                </i>
            </span>
        </div>
    </div>
    <aa-validation2 [dirty]="dirty"
                    [messages]="failures | async">
    </aa-validation2>
</div>
